import React, { ReactNode } from "react";
import { DataUtilities } from "../../rule-engine-core/Common/DataUtilities";
import { StateManager } from "../../rule-engine-core/Common/StateManager";

/**

 <ObserveMultiState
 listenTo={[anobject, anobject]}
 control={() => {
        return (

        );
    }}
 />
 **/

export class ObserveMultiState extends React.Component<{
    listenTo: (object | null | undefined)[];
    control: () => JSX.Element | ReactNode;
    onWillUnmount?: () => void;
}> {
    render() {
        return <React.Fragment key={DataUtilities.generateUniqueId()}>{this.props.control()}</React.Fragment>;
    }

    componentDidUpdate(prevProps: {
        listenTo: (object | null | undefined)[];
        control: () => JSX.Element | ReactNode;
        onWillUnmount?: () => void;
    }) {
        for (let obj of this.props.listenTo) {
            if (obj && !prevProps.listenTo.includes(obj)) {
                StateManager.addObserver(obj, this);
            }
        }

        for (let obj of prevProps.listenTo) {
            if (obj && !this.props.listenTo.includes(obj)) {
                StateManager.removeObserver(obj, this);
            }
        }
    }

    componentDidMount() {
        if (this.props.listenTo) {
            for (let l of this.props.listenTo) {
                if (l) StateManager.addObserver(l, this);
            }
        }
    }

    componentWillUnmount() {
        if (this.props.listenTo) {
            for (let l of this.props.listenTo) {
                if (l) StateManager.removeObserver(l, this);
            }
        }

        if (this.props.onWillUnmount) {
            this.props.onWillUnmount();
        }
    }
}
